export default "__VITE_ASSET__Dqe4t3rL__"